import React from 'react';
import styled from 'styled-components';

import { ClarifyingQuestionBlock } from '../../types';
import { ResponseActions } from '../ResponseActionButton';
import { useResponseAction } from '../responseActions';
import { ResponseReply } from '../responsePrimitives';
import { responseType, rsColor, rsv } from '../responseScale';

// 6422:10677: left-aligned beside the mark, hugging its text.
const QuestionBubble = styled.p`
  align-self: flex-start;
  max-width: 100%;
  margin: 0;
  padding: ${rsv.space('questionBubble')}px;
  border-radius: ${rsv.radius('questionBubble')};
  background: ${rsColor.questionBubble};
  box-shadow: ${rsColor.bubbleGlow};
  color: ${rsColor.white};
  white-space: pre-line;
  overflow-wrap: anywhere;
  ${responseType('question')}
`;

/** Figma 6422:10677: Orbit asks back, with optional quick replies. */
const ClarifyingQuestion: React.FC<{ block: ClarifyingQuestionBlock }> = ({ block }) => {
  const emit = useResponseAction(block);
  return (
    <ResponseReply data-testid="orbit-response-clarifying_question" data-block-id={block.id}>
      <QuestionBubble>{block.question}</QuestionBubble>
      <ResponseActions actions={block.options} onAction={emit} />
    </ResponseReply>
  );
};

export default ClarifyingQuestion;
